export default {"src":"/_next/static/media/mysql.2ddb80d9.svg","height":252,"width":256,"blurWidth":0,"blurHeight":0};